import { MoreHorizontal, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../../design-system/ui/dropdown-menu';

type BeneficiaryActionsMenuProps = {
  onDeleteBeneficiary: () => void;
};

export const BeneficiaryActionsMenu = ({ onDeleteBeneficiary }: BeneficiaryActionsMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          size="icon"
          className="size-9 rounded-full"
          aria-label="Recipient actions"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen((prev) => !prev);
          }}
        >
          <MoreHorizontal size={16} />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="z-[9999] w-[200px]">
        <DropdownMenuGroup>
          <DropdownMenuItem onSelect={onDeleteBeneficiary}>
            <Inline space={2} align="center">
              <Trash2 className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm">Delete recipient</span>
            </Inline>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
